"use strict";
(function (SpinnerType) {
    SpinnerType[SpinnerType["normal"] = 0] = "normal";
    SpinnerType[SpinnerType["large"] = 1] = "large";
})(exports.SpinnerType || (exports.SpinnerType = {}));
var SpinnerType = exports.SpinnerType;

//# sourceMappingURL=Spinner.Props.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Spinner/Spinner.Props.js
 ** module id = 140
 ** module chunks = 0
 **/